import React, {Component} from 'react';
import Translator from "../helpers/Translator";
import {DOMAIN} from "./FareAlertContainer";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {submitFareAlert, toggleFareAlert} from "../actions/FareAlertActions";
import Loader from "../helpers/Loader";

class FareAlert extends Component {
    componentDidMount() {
        let translations = {};
        translations[DOMAIN] = JSON.parse(this.props.translations);
        this.translator = new Translator(translations, DOMAIN);
    }

    submit() {
        if (!this.props.submitted) {
            this.props.submitFareAlert(this.email.value, this.props.currency, this.props.alertUrl);
        }
    }

    toggle() {
        this.props.toggleFareAlert();
    }

    render() {
        if (Loader.showLoader(this.props.flights)) {
            return null;
        }

        return (
            <div id="accordion" className={`fare-alert mb-3 cursor-pointer ${this.props.opened ? 'opened' : ''}`} role="tablist" aria-multiselectable="true">
                <div className="card">
                    <div className="card-header text-xs-center" role="tab" onClick={this.toggle.bind(this)}>
                        <button data-toggle="collapse" className="btn btn-link border-0 p-0">
                            <span className="icon-alert"></span> {this.translator.trans('Fare alert')}
                        </button>
                    </div>
                    <div className={this.props.opened ? '' : 'collapse'} role="tabpanel" data-parent="#accordion">
                        <div className="card-body">
                            <div className="form-group">
                                <label className="text-muted">
                                    <small>{this.translator.trans('Get a daily update of the cheapest price for this search.')}</small>
                                </label>
                                <input type="text" className="form-control alert-email" ref={(ref) => this.email = ref}
                                       placeholder={this.translator.trans('Your e-mail address')}/>
                            </div>
                            <div className={`alert alert-success ${!this.props.submitted ? 'hide' : ''}`}
                                 role="alert">{this.translator.trans('You have successfully registered to fare alert!')}</div>
                            <button className="btn btn-success btn-block create-alert" onClick={this.submit.bind(this)}
                               role="button">{this.translator.trans('Subscribe')}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        submitFareAlert,
        toggleFareAlert
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        submitted: state.FareAlertReducer.submitted,
        opened: state.FareAlertReducer.opened,
        flights: state.FlightsReducer,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FareAlert);




// WEBPACK FOOTER //
// ./src/components/FareAlert.js